<template>
  <div>
    <v-hover>
      <template v-slot:default="{ hover }">
        <v-card class="mx-auto" max-width="344">
          <div
            v-bind:class="[
              chapter && chapter.place != null ? '' : 'no-place',
              'google-map',
            ]"
            ref="googleMapPreview"
          ></div>

          <v-fade-transition>
            <v-overlay v-if="hover" absolute color="#036358">
              <v-btn color="red lighten-2" @click="dialog = !dialog">
                {{ $t("location.editLocation") }}
              </v-btn>
            </v-overlay>
          </v-fade-transition>
        </v-card>
      </template>
    </v-hover>
    <v-text-field :label="$t('chapter.streetAddress')" class="ma-3" v-if="chapter.place && chapter.place.name" :value="chapter.place.name" readonly dense outlined></v-text-field>
    <CoordinatesTextField class="ma-3" v-if="chapter.place != null" :latitude="chapter.place.latitude" :longitude="chapter.place.longitude" />
    <v-btn
      v-show="chapter.place == null"
      color="red lighten-2"
      @click="dialog = !dialog"
    >
      {{ $t("location.editLocation") }}
    </v-btn>
    <v-dialog eager v-model="dialog">
      <ChapterLocationDialog
        :chapter="chapter"
        @dialog="dialog = $event"
        :markerSettings="markerSettings"
      />
    </v-dialog>
  </div>
</template>
<script>
import ChapterLocationDialog from "./ChapterLocationDialog";
import { DEFAULT_MAP_ZOOM } from "@/const";
import { Loader } from "@googlemaps/js-api-loader";
import CoordinatesTextField from "./CoordinatesTextField"
export default {
  props: {
    chapter: Object,
  },
  data() {
    return {
      loader: null,
      marker: null,
      map: null,
      dialog: false,
      markerSettings: {
        fillColor: this.$vuetify.theme.themes.light.primaryAction,
        fillOpacity: 0.1,
        strokeColor: this.$vuetify.theme.themes.light.primaryAction,
        strokeWeight: 3,
        suppressUndo: true,
      },
    };
  },
  components: {
    ChapterLocationDialog,
    CoordinatesTextField,
  },
  mounted() {
    this.loadMap(this.chapter.place);
  },
  watch: {
    chapter(newValue) {
      this.loadMap(newValue.place);
    },
  },
  methods: {
    loadMap(place) {
      this.map = null;

      if (place != null) {
        if (this.map != null) {
          let latLng = { lat: place.longitude, lng: place.latitude };
          this.map.panTo(latLng);
          this.updateMarker(latLng);
        } else {
          this.loader = new Loader({
            apiKey: process.env.VUE_APP_GOOGLE_API,
            version: "weekly",
            libraries: ["drawing"],
          });

          this.loader.load().then(this.handleLoad);
        }
      }
    },
    updateMarker(pos) {
      if (this.marker && this.marker.map) {
        this.marker.setMap(null);
      }
      this.marker = null;
      // eslint-disable-next-line
      this.marker = new google.maps.Circle({
        ...this.markerSettings,
        center: pos,
        radius: this.chapter.place.radius,
        map: this.map,
        draggable: false,
        editable: false,
      });
    },
    handleLoad() {
      const mapContainer = this.$refs.googleMapPreview;
      // eslint-disable-next-line
      let map = new google.maps.Map(mapContainer, {
        center: {
          lat: this.chapter.place.latitude,
          lng: this.chapter.place.longitude,
        },
        draggable: false,
        zoomControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        zoom: DEFAULT_MAP_ZOOM,
      });
      this.map = map;

      if (this.chapter.place) {
        let latLng = {
          lat: this.chapter.place.latitude,
          lng: this.chapter.place.longitude,
        };

        this.updateMarker(latLng);

        this.map.panTo(latLng);
        this.map.setZoom(DEFAULT_MAP_ZOOM);
      }
    },
  },
};
</script>
<style scoped>
.google-map {
  width: 100%;
  height: 250px;
}
.google-map.no-place {
  height: 0;
}
</style>
